exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-dropdown-themeSelection {\n  background-color: #1594A6;\n  display: block; }\n\n.icon-position {\n  padding-top: 5px; }\n\n.alert {\n  background-color: transparent !important; }\n\n#stakeholdersTitle {\n  font-size: 1.5em;\n  margin-bottom: 1em; }\n\n.riskIndicatorName {\n  background: #f2f2f2;\n  line-height: 2em; }\n\n.progressBackground {\n  background: transparent !important;\n  height: 2em; }\n\n.progressForeground1 {\n  background: #1594A6 !important; }\n\n.progressForeground2 {\n  background: #f1cb8f !important; }\n\n.progressLabel {\n  padding-top: 0.6em !important; }\n\n.progressRow {\n  vertical-align: middle;\n  line-height: 2em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/retrospective-wizard-4-results/retrospective-wizard-4-results.component.scss
// module id = ../../../../../src/app/components/retrospective-wizard-4-results/retrospective-wizard-4-results.component.scss
// module chunks = main